import { IMobileOffer } from "@nju/data-access-portal-offers";
import {
  IFtthOrchestrator,
  IMobileOrchestrator,
  IMultiOrderOrchestrator,
} from "@nju/data-access-portal-orchestrator";
import { IconName } from "@nju/icons";
import { IScope } from "@nju/scope";
import { Heading, IconListElement, Separator } from "@nju/ui";

interface ISidebarMobileOfferBenefitsProps {
  installationPrice: string;
  extras: IMobileOffer["extraShortFeatures"];
  benefits: IMobileOffer["shortFeatures"];
  bundleDiscount: number | undefined;
  isFreeFromActivationFee: boolean;
  orchestrator:
    | IFtthOrchestrator
    | IMobileOrchestrator
    | IMultiOrderOrchestrator
    | undefined;
  variant?: IScope;
  paymentFeatures: IMobileOffer["paymentFeatures"] | undefined;
  discountFeatures: IMobileOffer["discountFeatures"] | undefined;
  bonusFeatures: IMobileOffer["bonusFeatures"] | undefined;
}

export function SidebarMobileOfferBenefits({
  benefits,
  bundleDiscount,
  orchestrator,
  variant = "portal",
  discountFeatures,
  bonusFeatures,
}: ISidebarMobileOfferBenefitsProps) {
  return (
    <>
      <Separator size="s" tone="invisible" />
      <Heading font="ttfirs" tone="neutral" variant="h4" weight="bold">
        rabaty
      </Heading>
      <Separator size="xxs" tone="invisible" />
      {discountFeatures?.map((feature) => {
        //const check if feature name has partly suffix "_HIGHLIGHT"
        const isDashedBorder = feature.name.endsWith("_HIGHLIGHT");
        return (
          <>
            {isDashedBorder && (
              <IconListElement
                borderStyle="dashed"
                darkTooltipIcon={true}
                iconAlign="start"
                iconName={feature.icon as IconName}
                iconSize="medium"
                mode="markdown"
                testId="discounts-info-box"
                text={feature.description.pl}
                tooltipContent={feature.additionalDescription?.pl}
                tooltipIconCentered={true}
              />
            )}
          </>
        );
      })}
      {bonusFeatures && (
        <>
          <Separator size="xs" tone="invisible" />
          <Heading font="ttfirs" tone="neutral" variant="h4" weight="bold">
            bonusy
          </Heading>
          <Separator size="xxs" tone="invisible" />
          {bonusFeatures?.map((feature) => {
            //const check if feature name has partly suffix "_HIGHLIGHT"
            const isDashedBorder = feature.name.endsWith("_HIGHLIGHT");
            return (
              <>
                {isDashedBorder && (
                  <IconListElement
                    borderStyle="dashed"
                    darkTooltipIcon={true}
                    iconAlign="start"
                    iconName={feature.icon as IconName}
                    iconSize="medium"
                    mode="markdown"
                    text={feature.description.pl}
                    tooltipContent={feature.additionalDescription?.pl}
                    tooltipIconCentered={true}
                  />
                )}
              </>
            );
          })}
        </>
      )}
      <Separator size="xs" tone="invisible" />
      <Heading font="ttfirs" tone="neutral" variant="h4" weight="bold">
        oferta
      </Heading>
      <Separator size="xxs" tone="invisible" />
      {benefits.map((benefit, index) => {
        return (
          <IconListElement
            iconAlign="start"
            iconName={benefit.icon as IconName}
            iconSize="big"
            key={index}
            mode="markdown"
            text={benefit.description.pl}
          />
        );
      })}
      {(!orchestrator ||
        (orchestrator?.type === "NJU_MOBILE_ONBOARDING" &&
          !orchestrator?.orderSummary?.discount)) &&
        bundleDiscount &&
        variant === "sales" && (
          <div className="border-1 border-cerulean border-dashed rounded-[12px] px-3 mt-1">
            <IconListElement
              iconAlign="start"
              iconName="badge-percent"
              iconSize="medium"
              mode="raw"
              text={`w pakiecie taniej - jeśli masz już aktywny nju światłowód, Twój nju subskrypcja będzie tańszy o ${bundleDiscount} zł miesięcznie.`}
            />
          </div>
        )}
    </>
  );
}
